export const offlinePayments = {
    "notSet": "No determinado",
    "credit_card": "Tarjeta de crédito",
    "cheque_deposit": "Cheque automático",
    "tenant_record": "Registro de inquilino",
    "bankCharge": "Cargo bancario de Bllink",
    "type_of_payment": "Tipo de pago",
    "pay_with_cheque_title": "Pagar con cheque",
    "pay_with_cash_title": "Registrar el pago en efectivo",
    "pay_with_wire_title": "Registrar transferencia bancaria",
    "pay_with_tenant_record": "Récord de reclamo de inquilino pagado",
    "bank_code_title": "Banco",
    "bank_branch_title": "Sucursal",
    "bank_account_number_title": "Número de cuenta",
    "make_offline_payment_button": "Registrar el pago",
    "date_of_deposit": "Fecha de depósito",
    "recurrent_bank_wires": "Transferencia bancaria recurrente",
    "payment_date": "Payment date",
    "cheque_number": "Número de cheque",
    "cheque_number_placeholder": "Ingresa el monto de los cheques",
    "add_row_tooltip": "Completa la fila anterior y completaremos automáticamente los valores para las siguientes filas",
    "auto_cheque_explanation1": "Después de llegar a esta pantalla, asegúrese de que el escáner de cheques esté conectado. Y el software del escáner (CI3) se ejecuta y aparece en verde.",
    "auto_cheque_explanation2": "Asegúrate de que el cursor del mouse aparezca en el cuadro 'Banco'.",
    "auto_cheque_explanation3": "Puede ingresar todos los cheques para el apartamento a la vez en el escáner de cheques. Después de cada escaneo, se mostrará una ventana de escaneo de datos para el escáner de cheques",
    "partial_pay": "Pago parcial",
    "payment": "Pagar",
    "cancellation": "Cancelar",
    "deny": "Negar",
    "denyTenantRecord": "cancel tenant record",
    "approveTenantRecord": "approve tenant record",
    "partial_sum_must_be_smaller": "El monto parcial debe ser menor que el monto del mes o el pago único seleccionado {{fullAmount}}",
    "auto_cheque_explanation4": "El sistema escribirá los datos en este formulario después de cada clic en la palomita verde en el software del escáner de cheques.",
    "auto_cheque_explanation5": "Para ir a la siguiente verificación, puede hacer clic en el botón de bloqueo de mayúsculas",
    "auto_cheque_explanation6": "Después de pasar todos los cheques, elimine la última línea, verifique la exactitud de los datos y haga clic en 'Documentación de pago'.",
    "cheque": "Cheque",
    "wire": "Transferir",
    "cash": "Depósito en ventanilla",
    "date": "Fecha",
    "confirmation": "Confirmar",
    "approve": "Aprobar",
    "tenant_record_modal_text": "Estás informando que los artículos seleccionados están pagados. La acción enviará la información al administrador del edificio",
    "amount": "Monto",
    "reccurent_wire_tooltip": "Un cheque aquí configurará una transferencia mensual mes a mes",
    "tenant_offline_payment_success": "Un mensaje ha sido enviado con éxito a la empresa de gestión",
    "tenant_offline_payment_failed": "No se puede enviar el mensaje a la empresa de administración. Intenta más tarde",
    "status": "Estado"
};
